import { isActionVisible } from './action-state';
import type { EntityAction } from './entity-action';

/**
 * Flattens groups into one array with a separator between them. The separator has its own `visible`:
 * shown only when both neighbouring groups have a visible action for the given entity — per-row
 * visibility can empty either group.
 */
export function withSeparators<T>(groups: EntityAction<T>[][]): EntityAction<T>[] {
  const hasVisible = (group: EntityAction<T>[], entity: T) => group.some((action) => isActionVisible(action, entity));

  return groups.flatMap((group, i) =>
    i === 0
      ? group
      : [
          { separator: true, visible: (entity: T) => hasVisible(groups[i - 1], entity) && hasVisible(group, entity) },
          ...group,
        ],
  );
}
